import React, { memo } from "react";

import { formatCurrency } from "helpers";
import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";

import { getBasePrice, getEquipmentLabels, getListingTitle, getSpecsLine } from "../helpers";
import { ListingSceneProps } from "../types";
import AdImage from "./AdImage";

const EQUIPMENT_COUNT = 4;

/** Korak podataka oglasa: oglas kako će izgledati na portalu, istaknuta oprema i podaci preuzeti iz vozila. */
const AdDataScene: React.FC<ListingSceneProps> = ({ formValues }) => {
  const equipment = getEquipmentLabels(formValues, EQUIPMENT_COUNT);

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        {/* Traka portala: oglas se prikazuje onako kako ga kupac vidi na oglasniku. */}
        <div className="flex items-center gap-2 px-5 py-2 rounded-t-lg bg-violet-500 text-[0.65rem] font-semibold text-white">
          <span className="w-2 h-2 rounded-full bg-white/80" />
          marketplace.hr
        </div>
        <div className="p-5">
          <AdImage formValues={formValues} className="h-[6.5rem] rounded-md" />
          <div className="mt-3 text-sm font-bold text-slate-800 truncate">{getListingTitle(formValues)}</div>
          <div className="mt-1 text-base font-bold text-red-600">{formatCurrency.format(getBasePrice(formValues))}</div>
          <div className="mt-1 text-[0.65rem] text-slate-400 truncate">{getSpecsLine(formValues)}</div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Oprema</div>
          <div className="mt-3 flex flex-wrap gap-1.5">
            {equipment.map((label) => (
              <span key={label} className="px-2 py-0.5 rounded-full bg-slate-100 text-[0.65rem] font-medium text-slate-700 truncate max-w-full">
                {label}
              </span>
            ))}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Popunjeno iz vozila"
          subtitle="Provjerite i dopunite podatke"
          iconClassName="bg-emerald-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#047857" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M12 20h9M16.5 3.5a2.1 2.1 0 013 3L7 19l-4 1 1-4 12.5-12.5z" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(AdDataScene);
